import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import { NewsroomState } from 'b2b-apps/shop/content/redux/newsroom/types';
import { NewsroomAssetsType, NewsroomNewsType } from 'b2b-common/core/content/api/Newsroom.types';

const getState = (state: State): NewsroomState => state.content.newsroom;

const getNewsroomAssets = (
  state: State,
): RemoteRecord<NewsroomAssetsType> => new RemoteRecord(getState(state).assets);

const getNewsroomNews = (
  state: State,
): RemoteRecord<NewsroomNewsType> => new RemoteRecord(getState(state).news);

export {
  getNewsroomAssets,
  getNewsroomNews,
  getState,
};
